<template>
  <BaseViewComponent
    name="headlines"
    :is-preview="isPreview"
  >
    <div class="headlines-wrapper with-button full-width text-center">
      <div class="container">
        <div class="text text-center">
          <div class="title-h2">
            {{ pageData.headlinesWithButtonTitle }}
          </div>
          <div class="text-p">
            {{ pageData.headlinesWithButtonDescription }}
          </div>
          <AppBtn
            :label="pageData.headlinesWithButtonText"
            class="border-radius-10 btn-landing"
            padding="10px 20px"
            @click="onClick"
          />
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import AppBtn from 'components/AppBtn.vue';
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

function onClick() {
  window.open(pageData.value.headlinesWithButtonUrl, '__blank');
}
</script>
